<!-- App.vue -->
<template>
  <div id="app">
    <AppHeader />

    <!-- 路由视图：只有访问详情页时才显示 -->
    <router-view></router-view>

    <!-- 首页内容：只在首页显示 -->
    <template v-if="$route.path === '/'">
      <HeroSection />
      <AboutSection />
      <!-- <BusinessSection /> -->
      <AdvantagesSection />
      <PartnersSection />
      <StrategySection />
    </template>

    <AppFooter />
  </div>
</template>

<script>
import AppHeader from "./components/AppHeader.vue";
import HeroSection from "./components/HeroSection.vue";
import BusinessSection from "./components/BusinessSection.vue";
import AdvantagesSection from "./components/AdvantagesSection.vue";
import PartnersSection from "./components/PartnersSection.vue";
import StrategySection from "./components/StrategySection.vue";
import AboutSection from "./components/AboutSection.vue";
import AppFooter from "./components/AppFooter.vue";

export default {
  name: "App",
  components: {
    AppHeader,
    HeroSection,
    BusinessSection,
    AdvantagesSection,
    PartnersSection,
    StrategySection,
    AboutSection,
    AppFooter,
  },
};
</script>
